import React, { useState, useEffect, createContext, useContext } from 'react';
import WPApiFetch from '../Utility/WPApi'
import { useAuth } from "../Contexts/AuthContext"

export const UserVideoProgressContext = createContext({
	videoProgress: null,
	videoProgressLoaded: false,
	setVideoProgress: () => {},
	setVideoProgressLoaded: () => {}
});

export default function UserVideoProgressProvider({children}) {
	const [videoProgress, setVideoProgress] = useState();
	const [videoProgressLoaded, setVideoProgressLoaded] = useState(false);
	const value = { videoProgress, setVideoProgress, videoProgressLoaded, setVideoProgressLoaded };
	const { nonce } = useAuth();

	useEffect(() => {
	    async function fetchVideoProgress() {
		   	const data = await WPApiFetch('/r-flix/v1/getprogress', this, "POST", null, "include", nonce);
			setVideoProgress( data );
			setVideoProgressLoaded(true);
	    }
	    nonce && !videoProgressLoaded && fetchVideoProgress();
	}, [nonce, videoProgressLoaded])

	return <UserVideoProgressContext.Provider value={value}>{children}</UserVideoProgressContext.Provider>
}

export function useUserVideoProgress() {
	const context = useContext(UserVideoProgressContext);
	if (context === undefined) {
		throw new Error("Context must be used within a Provider");
	}
	return context;
}